import React from "react";
import { Link } from "react-router-dom";
import DataSender from "../lib/DataSender";

class Setting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.ds = new DataSender();
  }

  logout() {
    this.ds.logout().then(() => {
      window.location.pathname = "/";
    });
  }

  render() {
    return (
      <div className="main-setting">
        <div className="wrapper">
          <h1>환경설정</h1>
        </div>
        <div className="qrcreate-buttons">
          <div className="qrcreate-button1">
            <button className="button">
              <p>적용하기</p>
            </button>
          </div>
          <div className="qrcreate-button2">
            <button className="button" onClick={this.logout.bind(this)}>
              <p>로그아웃</p>
            </button>
          </div>
          <Link to="/" className="qrcreate-button3">
            <button className="button">
              <p>메인으로</p>
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default Setting;
